export const POSITIVE_FEEDBACK_COMMENTS = [
  "Accurate information",
  "Found what I needed",
  "Easy to read",
  "Helpful links",
  "Simple to use",
  "Something else",
];

export const NEGATIVE_FEEDBACK_COMMENTS = [
  "Not accurate",
  "Didn't find what I needed",
  "Hard to follow",
  "Missing information",
  "Harmful or offensive",
  "Something else",
];

export const FREE_TEXT_COPY = "Thanks for your feedback. Why did you choose this?";
